import type {
    SxProps,
    Theme
} from '@mui/material/styles';

const styles = {
    wrapper: {
        display: 'flex',
        gap: 2,
        width: {
            md: 'auto',
            xs: '100%'
        }
    }
} satisfies Record<string, SxProps<Theme>>;

export default styles;
